// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7213179a","732":"17ef94ff","977":"c3d99690"}[chunkId] + ".chunk.js";
};